import * as Sentry from '@sentry/react';

import { FrontendError } from './frontend-error';

export const FRONTEND_ERROR_BUFFER_LIMIT = 50;

export type FrontendErrorEntry = {
  id: string;
  code: string;
  cause?: unknown;
  capturedAt: number;
  meta?: Record<string, unknown>;
};

const buffer: FrontendErrorEntry[] = [];

export function captureFrontendError(err: unknown, origin: string, meta?: Record<string, unknown>): string {
  const fe = err instanceof FrontendError ? err : new FrontendError({ code: 'errors.generic.unexpected', cause: err });

  const entry: FrontendErrorEntry = {
    id: fe.id,
    code: fe.code,
    capturedAt: fe.capturedAt,
    meta: { origin, ...meta },
  };

  if (fe.cause !== undefined) entry.cause = fe.cause;

  buffer.push(entry);

  if (buffer.length > FRONTEND_ERROR_BUFFER_LIMIT) buffer.shift();

  Sentry.withScope((scope) => {
    scope.setTag('error.id', fe.id);
    scope.setTag('error.code', fe.code);
    scope.setContext('frontend', { origin, ...(meta ?? {}) });
    Sentry.captureException(fe.cause ?? fe);
  });

  return fe.id;
}

export function readFrontendErrorBuffer(): readonly FrontendErrorEntry[] {
  return buffer;
}

export function clearFrontendErrorBuffer(): void {
  buffer.length = 0;
}
